export default defineNuxtRouteMiddleware(async () => {
  // Public pages (the scoreboard) stay open to everyone but still want to know
  // who's signed in — for the wager slip's balance and place-bet. Resolve the
  // probook_session at SSR (same as the auth middleware) WITHOUT redirecting, so
  // the slip renders the right state and the client hydrates the same tree.
  const { user, fetchMe } = useAuth()
  if (process.server && !user.value) await fetchMe()
})
